import { Text } from "@/components/Text";
import { Card, Separator, Skeleton } from "@/components/ui";
import { useFaucetStatus } from "@/hooks/api/useFaucet";
import { sanitizeNumber } from "@/lib/utils";
import { useMemo } from "react";

export function TokenBalances() {
  const { data, isLoading } = useFaucetStatus();

  // Sort tokens: native tokens first, then by symbol
  const sortedTokens = useMemo(() => {
    const tokens = data?.tokens ?? [];
    return [...tokens].sort((a, b) => {
      if (a.isNative && !b.isNative) return -1;
      if (!a.isNative && b.isNative) return 1;
      return a.symbol.localeCompare(b.symbol);
    });
  }, [data?.tokens]);

  return (
    <Card variant="secondary">
      <Text variant="subheading">Token Balances</Text>
      <div
        data-active={data?.active}
        className="grid gap-2 data-[active=false]:opacity-50 mt-4 @container"
      >
        <div className="@max-xs:hidden">
          <div className="grid grid-cols-5 gap-3">
            <Text variant="muted" className="col-span-2">
              Name
            </Text>
            <Text variant="muted" className="col-span-2 text-end">
              Balance
            </Text>
            <Text variant="muted" className="text-end">
              Drip Size
            </Text>
          </div>
          <Separator className="mt-2" />
        </div>
        {isLoading &&
          [...Array(7)].map((item, index) => {
            return (
              <div key={item} className="space-y-5">
                <div className="grid gap-3">
                  <Skeleton isLoading={true}>
                    <Text>Loading</Text>
                  </Skeleton>
                </div>
                {index !== 6 && <Separator />}
              </div>
            );
          })}

        {sortedTokens?.map((token, index) => {
          return (
            <div key={`${token.name}-${token.id}`} className="space-y-5">
              <div className="grid @xs:grid-cols-5 @2xs:max-xs:grid-cols-2 grid-cols-1 gap-3">
                <Text
                  data-native={token.isNative}
                  className="@xs:col-span-2 data-[native=true]:text-text-accent text-nowrap"
                >
                  {token.symbol}{" "}
                  <span className="text-muted-foreground text-xs">
                    ({token.name})
                  </span>
                  {!token.active && (
                    <span className="ml-1 text-xs text-red-400">Inactive</span>
                  )}
                </Text>
                <div className="@xs:col-span-2 @xs:text-end">
                  <Text>{sanitizeNumber(token.balance, token.decimals)}</Text>
                  <Text variant="muted" className="text-xs @xs:hidden">
                    Balance
                  </Text>
                </div>
                <div className="@xs:text-end">
                  <Text className="">
                    {sanitizeNumber(token.standardAmount, token.decimals)}
                  </Text>
                  <Text variant="muted" className="text-xs @xs:hidden">
                    Drip size
                  </Text>
                </div>
              </div>
              {sortedTokens.length - 1 !== index && <Separator />}
            </div>
          );
        })}
      </div>
    </Card>
  );
}
